import { Form, Tooltip, Switch, Icon } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";

import styled from "styled-components/macro";

const TooltipContent = styled.div`
  display: flex;
  justify-content: center;
  gap: 15px;
  margin: 5px;

  .icon {
    font-size: 20px;
    margin-top: 10px;
  }
`;

const Text = styled.span`
  color: ${({ theme, checked, disabled }) =>
    checked && !disabled && theme["@primary"]};
`;

function SwitchPublicData({ form, field, disabled }) {
  const { t } = useTranslation();
  return (
    <div style={{ display: "flex" }}>
      <Form.Item>
        {form.getFieldDecorator(field, {
          initialValue: true,
          valuePropName: "checked"
        })(<Switch disabled={disabled} style={{ marginLeft: 10 }} />)}
      </Form.Item>
      <div style={{ marginLeft: 10 }}>
        <Tooltip
          title={
            <TooltipContent>
              <div>
                <Icon className="icon" type="eye" />
              </div>
              <div>
                <div style={{ textTransform: "uppercase" }}>
                  {t("global:publicData").toUpperCase()}
                </div>
                <div>{t("global:publicDataHelp")}</div>
              </div>
            </TooltipContent>
          }
        >
          <Text checked={form.getFieldValue(field)} disabled={disabled}>
            {t("global:publicData")}
          </Text>
        </Tooltip>
      </div>
    </div>
  );
}

export default SwitchPublicData;
